import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../config/userProvider";
import { removeCookie } from "../config/webStorage";
import { motion } from "framer-motion";
import {
  Building2,
  LineChart,
  Wallet,
  LogOut,
  DoorOpen,
  User,
  Mail,
} from "lucide-react";

const iconMap = {
  hrms: <Building2 className="text-blue-500 w-6 h-6" />,
  sales: <LineChart className="text-green-500 w-6 h-6" />,
  payroll: <Wallet className="text-purple-500 w-6 h-6" />,
};

const portalNames = {
  hrms: "HRMS",
  sales: "Sales",
  payroll: "Payroll",
};

const PortalLander = () => {
  const { userData } = useUser();
  const navigate = useNavigate();
  const [confirmLogout, setConfirmLogout] = useState(false);

  useEffect(() => {
    if (userData?.portal?.length === 1) {
      navigate(`/${userData.portal[0]}/dashboard`);
    }
  }, [userData, navigate]);

  const handleLogout = () => {
    removeCookie("swtoken");
    navigate("/");
  };

  const handlePortalClick = (portal) => {
    navigate(`/${portal}/dashboard`);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-gray-50 to-blue-50 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-white shadow-xl rounded-2xl w-full max-w-md p-6"
      >
        {/* Header */}
        <div className="text-center mb-6">
          <motion.div
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.3 }}
            className="flex items-center justify-center mx-auto w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-indigo-500 text-white mb-3"
          >
            <User className="w-6 h-6" />
          </motion.div>
          <h2 className="text-2xl font-bold text-gray-800 capitalize">
            Welcome, {userData?.firstName || "User"} 👋
          </h2>
          <p className="text-sm text-gray-500">{userData?.email}</p>
        </div>

        {/* Available Portals */}
        <div className="mb-6">
          <p className="text-center text-sm font-semibold text-gray-600 mb-3">
            Choose a portal to continue
          </p>
          {userData?.portal?.length ? (
            <div className="space-y-3">
              {userData.portal.map((portal) => (
                <motion.div
                  key={portal}
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.97 }}
                  onClick={() => handlePortalClick(portal)}
                  className="flex items-center justify-between p-3 bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200 rounded-lg cursor-pointer hover:from-blue-50 hover:to-indigo-50 transition-all duration-200"
                >
                  <div className="flex items-center space-x-3">
                    {iconMap[portal]}
                    <span className="text-gray-800 font-medium text-sm">
                      {portalNames[portal] || portal.toUpperCase()}
                    </span>
                  </div>
                  <DoorOpen className="w-4 h-4 text-blue-500" />
                </motion.div>
              ))}
            </div>
          ) : (
            <p className="text-center text-red-500 text-sm">
              No portal access available.
            </p>
          )}
        </div>

        {/* Logout Button */}
        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setConfirmLogout(true)}
          className="w-full py-2 rounded-lg bg-gradient-to-r from-red-500 to-pink-500 text-white font-medium shadow hover:opacity-90 transition"
        >
          <LogOut className="inline-block w-4 h-4 mr-2" />
          Logout
        </motion.button>
      </motion.div>

      {/* Logout Modal */}
      {confirmLogout && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
        >
          <motion.div
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            className="bg-white rounded-xl shadow-2xl p-6 w-80 text-center"
          >
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              Confirm Logout
            </h3>
            <p className="text-sm text-gray-500 mb-5">
              Are you sure you want to log out?
            </p>
            <div className="flex justify-center gap-3">
              <button
                onClick={handleLogout}
                className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition"
              >
                Logout
              </button>
              <button
                onClick={() => setConfirmLogout(false)}
                className="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 transition"
              >
                Cancel
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};

export default PortalLander;





// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useUser } from "../config/userProvider";
// import { FaBuilding, FaChartLine, FaWallet } from "react-icons/fa";
// import { removeCookie } from "../config/webStorage";
// import axios from "axios";
// import { apiurl } from "../config/config";

// const iconMap = {
//   hrms: <FaBuilding className="text-blue-600 text-xl" />,
//   sales: <FaChartLine className="text-green-600 text-xl" />,
//   payroll: <FaWallet className="text-purple-600 text-xl" />,
// };

// const portalNames = {
//   hrms: "HRMS",
//   sales: "Sales",
//   payroll: "Payroll",
// };

// // Whitelisted IPs
// const allowedIPs = ["14.195.66.42", "192.18.5.97"]; // Replace with real allowed IPs

// const PortalLander = () => {
//   const { userData } = useUser();
//   const navigate = useNavigate();
//   const [ip, setIp] = useState("");

//   useEffect(() => {
//     if (userData?.portal?.length === 1) {
//       navigate(`/${userData.portal[0]}/dashboard`);
//     }
//   }, [userData, navigate]);

//   // Logout Function
//   const handleLogout = () => {
//     removeCookie("swtoken");
//     navigate("/");
//   };

//   console.log("userData",userData);


//   const handlePortalClick = (portal) => {
//     navigate(`/${portal}/dashboard`);
//   };

//   // Get Public IP & Trigger API if Unauthorized
//   useEffect(() => {
//     const fetchIPAndValidate = async () => {
//       try {
//         const res = await axios.get("https://api.ipify.org?format=json");
//         const userIP = res.data.ip;
//         setIp(userIP);

//         // If IP not allowed → logout, redirect & trigger email API
//         if (!allowedIPs.includes(userIP)) {
//           removeCookie("swtoken");

//           // Send alert email API
//           await axios.post(`${apiurl}/api/user/send-unauthorized-email`, {
//             userData: {
//               userId: userData?.userId,
//               name: `${userData?.firstName} ${userData?.lastName}`,
//               email: userData?.email,
//               userId :userData?.id, 
//               employeeId :userData?.employeeId, 
//             },
//             publicIP: userIP,
//             localIPs: [], // Add local IPs if available
//           });

//           // Redirect to Danger Page
//           navigate("/danger");
//         }
//       } catch (err) {
//         console.error("Error fetching IP or sending alert:", err);
//       }
//     };

//     if (userData?.email) {
//       fetchIPAndValidate();
//     }
//   }, [userData, navigate]);

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
//       <div className="bg-white p-6 rounded-xl shadow-lg w-full max-w-md">
//         <h2 className="text-2xl font-bold text-center text-gray-800 mb-4">Welcome</h2>
//         <div className="text-center mb-6">
//           <p>Your IP: {ip}</p>
//           <p className="text-lg font-medium">
//             {userData?.firstName} {userData?.lastName}
//           </p>
//           <p className="text-sm text-gray-600">{userData?.email}</p>
//         </div>

//         <div className="mb-4">
//           <p className="text-sm font-semibold text-gray-700 mb-2 text-center">Available Portals</p>
//           {userData?.portal?.length > 1 ? (
//             <div className="space-y-3">
//               {userData.portal.map((portal) => (
//                 <div
//                   key={portal}
//                   onClick={() => handlePortalClick(portal)}
//                   className="flex items-center justify-between bg-gray-50 p-3 rounded-md shadow hover:bg-blue-50 cursor-pointer transition"
//                 >
//                   <div className="flex items-center space-x-3">
//                     {iconMap[portal]}
//                     <span className="text-sm font-medium text-gray-800">{portalNames[portal]}</span>
//                   </div>
//                   <span className="text-blue-500 text-xs">Go</span>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <p className="text-sm text-red-500 text-center">You do not have access to any portals.</p>
//           )}
//         </div>

//         <button
//           onClick={handleLogout}
//           className="mt-6 w-full bg-red-500 text-white py-2 rounded hover:bg-red-600"
//         >
//           Logout
//         </button>
//       </div>
//     </div>
//   );
// };

// export default PortalLander;